import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { ObjectType, Package } from '@/@types/graphql-types';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { getOfferImpressionContext, observableOptions } from '@/helpers/composables/useOfferImpressionTracking';
import { ImpressionTrackingEvents } from '@/enums/events';
import { BuyboxParam, OfferLocation, trackClickOutGraphql } from '@/helpers/offer-helper';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { usePromotion } from '@/helpers/composables/usePromotion';
import { TitleOffers } from '@/interfaces/buybox';
import { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import { useArbitrage } from '@/helpers/composables/useArbitrage';

interface PromotionRowProps {
	title: TitleDetail;
	allProvidersById: Record<number, Package> | null;
	offers: TitleOffers;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowV2',
  props: {
    title: null,
    allProvidersById: null,
    offers: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	allProvidersById: Record<number, Package> | null;
	offers: TitleOffers;
}

const priceByCountry = {
	US: '$9.99',
	UK: '£8.99',
	GB: '£8.99',
	CA: 'CA$12.99',
	AU: 'AU$12.99',
	PH: '₱369',
	CO: 'COP $29.900',
	AR: '$9.95',
};

const { country } = useLanguageStore();
const { isArbitrating, trackTagEvent, withArbitrageTracking } = useArbitrage();


const { promotionOffer } = usePromotion({
	title: () => props.title,
	offers: () => {
		const { free = [], stream } = props.offers;
		return [...free, ...stream];
	},
});

const observeVisibilityOptions = {
	...observableOptions,
	once: true,
	callback: (isVisible: boolean) => onVisibilityChanged(isVisible),
};

const clickoutLink = computed(() => {
	if (!promotionOffer.value) return undefined;
	const clickoutUrl = new ClickoutUrl(promotionOffer.value)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Normal);

	if (isArbitrating.value) {
		return withArbitrageTracking(clickoutUrl, promotionOffer).toString();
	}

	return clickoutUrl.set('uct_ct', 'natds_new').set('uct_itsct', 'justwatch_tv_13').toString();
});

function onVisibilityChanged(isVisible: boolean) {
	if (!isVisible) return;
	TrackingHelper.trackEvent(
		ImpressionTrackingEvents.OFFER,
		{
			action: 'impression',
			nonInteraction: true,
			value: OfferLocation.FREE_TRIAL,
			label: 'provider',
		},
		[getOfferImpressionContext(promotionOffer.value as TitleOfferFragment)]
	);
}

function onClickOut() {
	trackTagEvent(promotionOffer.value);
	trackClickOutGraphql({
		offer: promotionOffer.value as TitleOfferFragment,
		objectType: props.title.objectType,
		objectId: props.title.objectId,
		offerLocation: OfferLocation.FREE_TRIAL,
		contentType: undefined,
	});
}

return { __sfc: true,priceByCountry, country, isArbitrating, trackTagEvent, withArbitrageTracking, props, promotionOffer, observeVisibilityOptions, clickoutLink, onVisibilityChanged, onClickOut, ProviderIcon, ObjectType }
}

})